import React, { useEffect, useState } from "react";
import "./Step1.css";
import { Form } from "react-bootstrap";

function Step1({ next, setSegmentSuited, segmentSuited }) {
  const [selectedOption, setSelectedOption] = useState(""); // track selected radio

  const radioOptions = [
    "Online MBA Academic Advisors",
    "Gov. Exams (SSC, Banking, etc)",
    "University / College Admissions",
    "JEE / NEET Coaching",
    "Other (please specify)",
  ];

  
  const [otherValue, setOtherValue] = useState("");

  const handleSelect = (label) => {
    setSelectedOption(label);
    setSegmentSuited(label); // <-- store selected into setSegmentSuited

    if (label !== "Other (please specify)") {
      setOtherValue(""); // reset if not other
    }
  };
  useEffect(() => {
    if (selectedOption === "Other (please specify)") {
      setSegmentSuited(otherValue);
    }
  }, [otherValue])

  console.log(segmentSuited,"segmentSuited segmentSuited");
  
  return (
    <div className="step1_main">
      <h2 className="step_title">
        Just Answer <span>7</span> Simple questions to become a <br />
        <strong>Profcyma Partner</strong>
      </h2>

      <p className="step_subtitle">
        For Which segment are you best suited for?
      </p>

      <div className="form_holder">
        <div className="list_holder">
          {radioOptions.map((label, index) => (
            <label
              key={index}
              className={`option_box ${
                segmentSuited === label ? "active" : ""
              }`}
              onClick={() => handleSelect(label)}
            >
              {label}

              <Form.Check
                type="radio"
                name="seg"
                className="option_radio"
                value={label}
                checked={segmentSuited === label}
                onChange={() => handleSelect(label)}
              />
            </label>
          ))}
        </div>

        {/* Show input only when "Other" selected */}
        {selectedOption === "Other (please specify)" && (
          <input
            type="text"
            className="other_input"
            placeholder="Please specify"
            value={otherValue}
            onChange={(e) => setOtherValue(e.target.value)}
          />
        )}
      </div>

      <div className="step_btns">
        <button onClick={next} className="next_btn">
          Next
        </button>
      </div>
    </div>
  );
}

export default Step1;
